export const iconFontAwesomeUsersPeoplePersonCircleXmark = (
	<i className="fa-solid fa-person-circle-xmark"></i>
);
